import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input, Label } from '../../ui/input';
import { toast } from 'sonner';
import { Webhook, Save, RotateCcw, MonitorSmartphone } from 'lucide-react';
import { http as api } from '../../../lib/api';

const AppriseRoutingConfig = () => {
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState({});

    useEffect(() => {
        fetchConfigs();
    }, []);

    const fetchConfigs = async () => {
        try {
            const response = await api.get('/admin/advanced/notifications/config');
            setConfigs(response.data);
        } catch (error) {
            console.error(error);
            toast.error("Error cargando configuración de notificaciones");
        } finally {
            setLoading(false);
        }
    };

    const handleUrlChange = (section, value) => {
        setConfigs(prev => prev.map(c => 
            c.section === section ? { ...c, url: value } : c
        ));
    };

    const saveConfig = async (section) => {
        setSaving(prev => ({ ...prev, [section]: true }));
        try {
            const config = configs.find(c => c.section === section);
            await api.post('/admin/advanced/notifications/config', {
                section: section,
                url: config.url
            });
            toast.success(`Ruteo actualizado para ${section}`);
        } catch (error) {
            console.error(error);
            toast.error("Error guardando cambios");
        } finally {
            setSaving(prev => ({ ...prev, [section]: false }));
        }
    };

    if (loading) return <div>Cargando ruteo de notificaciones...</div>;

    return (
        <Card className="w-full">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Webhook className="h-5 w-5" />
                    Ruteo de Notificaciones Apprise
                </CardTitle>
                <CardDescription>
                    Define URLs específicas de Apprise para cada sección del sistema. 
                    Si la dejas vacía, se usará la URL por defecto del sistema.
                </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
                {configs.map((item) => (
                    <div key={item.section} className="grid gap-2 p-4 border rounded-lg bg-card/50">
                        <div className="flex items-center justify-between pb-2">
                            <Label className="uppercase text-xs font-bold text-muted-foreground tracking-wider">
                                {item.section}
                            </Label>
                            <div className="text-xs text-muted-foreground">
                                Default: {item.default_url ? 'Configurado' : 'No definido'}
                            </div>
                        </div>
                        
                        <div className="flex gap-2">
                            <div className="relative flex-1">
                                <MonitorSmartphone className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
                                <Input
                                    value={item.url || ''}
                                    onChange={(e) => handleUrlChange(item.section, e.target.value)}
                                    placeholder="https://apprise... o tgram://..."
                                    className="pl-9 font-mono text-sm"
                                />
                            </div>
                            <Button 
                                onClick={() => saveConfig(item.section)} 
                                disabled={saving[item.section]}
                                size="sm"
                            >
                                {saving[item.section] ? (
                                    <RotateCcw className="h-4 w-4 animate-spin" />
                                ) : (
                                    <Save className="h-4 w-4" />
                                )}
                            </Button>
                        </div>
                        <p className="text-[11px] text-muted-foreground">
                           Soporta URLs completas (http...) o esquemas stateless (tgram://, discord://).
                        </p>
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};

export default AppriseRoutingConfig;
